export default "__VITE_ASSET__YF91Rets__"